export default __webpack_public_path__ + "static/media/share-fb-icon.df7f1371.png";